import angular from 'angular';
import { FlipCameraMobileController } from './flip-camera-mobile';
import template from './flip-camera-mobile.html';
const component = {
    template,
    bindings: {
        isDisabled: '<',
    },
    controller: FlipCameraMobileController,
};
export default angular
    .module('doxy.common.components.flipCameraMobile', [])
    .component('flipCameraMobile', component).name;
